<template>
   <!-- Begin Brands -->
    <div class="uren-brand_area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title_area">
              <span>Top Quality Partner</span>
              <h3>Shop By <span class="text-primary-custom">Brands</span></h3>
            </div>
            <div class="brand-slider uren-slick-slider img-hover-effect_area" >
              <VueSlickCarousel v-bind="settingsCarousel">
                <div v-for="brand in brands" :key="brand.name" class="slide-item">
                  <div class="inner-slide">
                    <div class="single-product">
                      <a href="javascript:void(0)">
                        <img :src="brand.img" :alt="brand.name" :title="brand.name">
                      </a>
                    </div>
                  </div>
                </div>
              </VueSlickCarousel>



            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Brands End Here -->
</template>

<script>
export default {
  name: "Brands",
  data() {
    return {
      settingsCarousel: {
        "dots": false,
        "arrows": false,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 5,
        "slidesToScroll": 4,
        "initialSlide": 0,
        "responsive": [
          {
            "breakpoint": 1200,
            "settings": {
              "slidesToShow": 5,
            }
          },
          {
            "breakpoint": 992,
            "settings": {
              "slidesToShow": 3,
            }
          },
          {
            "breakpoint": 767,
            "settings": {
              "slidesToShow": 3,
            }
          },
          {
            "breakpoint": 577,
            "settings": {
              "slidesToShow": 2,
            }
          },
          {
            "breakpoint": 321,
            "settings": {
              "slidesToShow": 1,
            }
          },
        ]
      },
      brands: [
        {
          name: "Stanley",
          img: "/images/brand/1.jpg"
        },
        {
          name: "Lincoln",
          img: "/images/brand/2.jpg"
        },
        {
          name: "Levac",
          img: "/images/brand/3.jpg"
        },
        {
          name: "Ruko",
          img: "/images/brand/4.jpg"
        },
        {
          name: "Klingspor",
          img: "/images/brand/5.jpg"
        },
        {
          name: "LogoBrand",
          img: "/images/brand/7.jpg"
        },

      ]
    }
  }
}
</script>

<style>

</style>
